/**
 * Kod wygenerowany automatycznie przez automatyczne narz�dzie (problemy zg�asza� do Tomasza Grze�kiewicza)
 * nie zmieniaj tego pliku, wszystkie zmiany zostan� nadpisane automatycznie
 */
import {Api} from "../index";
import {ReactivityValidator} from "../../utils/ReactivityValidator"

export const SubBidder = {

	delete (context, userId, onSuccess, onError, options) {
		Api.delete(context,
			"/sub-bidder"
			+ "?userId=" + userId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getSubBidderType (context, onSuccess, onError, options) {
		Api.get(context,
			"/sub-bidder/sub-bidder-type"
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getSubBidderTypeFilter (context, onSuccess, onError, options) {
		Api.get(context,
			"/sub-bidder/sub-bidder-type-filter"
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getSubBidderTypeFilterById (context, bidderId, onSuccess, onError, options) {
		Api.get(context,
			"/sub-bidder/sub-bidder-type-filter-by-id"
			+ "?bidderId=" + bidderId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postResendVerificationEmail (context, userId, onSuccess, onError, options) {
		Api.post(context,
			"/sub-bidder/resend-verification-email"
			+ "?userId=" + userId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

};
